"use client";

import { useState, useEffect, useRef } from "react";
import { useSidebar } from "./SidebarContext";
import Popup from "./PopUp";
import { useNavigate } from "react-router-dom";

export default function AvatareDropdown() {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const { selectedAvatare, setSelectedAvatare, avatares ,setFetched} = useSidebar();
  const dropdownRef = useRef(null);

  useEffect(() => {
    setSelectedAvatare(avatares[avatares?.length - 1] || {});
  }, []);

  useEffect(() => {
    setFetched(true)
  }, []);

  useEffect(() => {
    setSelectedAvatare(avatares[avatares?.length - 1] || {});
    
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSelectProject = (project) => {
    setSelectedAvatare(project);
    setIsOpen(false);
  };

  const handleAddProject = () => {
    navigate("/admin/createAvatar");
  };
  return (
    <div className="w-[96%]  mt-2 relative" ref={dropdownRef}>
      <button
        onClick={toggleDropdown}
        className="flex items-center justify-between w-full px-4 py-2 text-white bg-transparent border border-white border-opacity-50"
      >
        <span className="text-xl font-medium">
          {selectedAvatare?.BotName || "No Bot Selected"}
        </span>
        <span className="ml-2">
          <img
            src="/arrow_dropdown.svg"
            className={`transform transition-transform duration-200 ${
              isOpen ? "" : "rotate-180"
            }`}
          />
        </span>
      </button>
      {isOpen && (
        <div
          className={`absolute w-full border border-t-0 border-white border-opacity-[0.30] bg-[#20556E] z-50 overflow-auto ${
            avatares?.length > 5 ? "h-[300px]" : "h-auto"
          }`}
        >
          <ul>
            {avatares.length > 0 && avatares?.map((Obj, index) => (
              <li
                key={index}
                className="border-b border-white border-opacity-[0.11] last:border-b-0"
              >
                <button
                  className={`w-full p-4 text-left text-white hover:bg-[#245c76] ${
                    selectedAvatare?.BotId === Obj?.BotId ? "bg-[#20556E]" : ""
                  }`}
                  onClick={() => handleSelectProject(Obj)}
                >
                  {Obj?.BotName}
                </button>
              </li>
            ))}
          </ul>

          <button
            className="flex items-center w-full p-4 text-white hover:bg-[#245c76] border-t border-white border-opacity-[0.11]"
            onClick={handleAddProject}
          >
            <span className="mr-2">
              <img src="/plus-project-icon.svg" alt="Add project" />
            </span>
            <span>Create New Avatare</span>
          </button>
        </div>
      )}
    </div>
  );
}
